import { useMemo } from 'react'
import styled from 'styled-components'
import FaqItem from './faqItem'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const FaqContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 1164px;
    padding: 80px 40px;
    background-color: white;
    margin-bottom: 72px;
`

export default function Faq() {
    const { i18n } = useTranslation('', { keyPrefix: 'helpcentre.enquiry' })
    const lang = i18n.language
    const configs = useSelector((state: any) => state.config.configs)
    const faqList = useMemo(() => configs?.helpcentre?.FAQList || [], [configs])

    const sortedFaqList = [...faqList].sort(function (a: any, b: any) {
        return a.id - b.id || a.question_en.localeCompare(b.question_en)
    })

    const faqItemsList = sortedFaqList.map((faqitem: any, index: number) => (
        <FaqItem
            key={'faq-' + index}
            question={lang === 'zh' ? faqitem.question_zh : faqitem.question_en}
            answer={lang === 'zh' ? faqitem.answer_zh : faqitem.answer_en}
            currentTab={'faq'}
        />
    ))
    return <FaqContainer>{faqItemsList}</FaqContainer>
}
